



















import { blankoElement, userRaid } from "models/Types";
import Vue, { PropType } from "vue";
import { Encounter } from "../../../../models/Encounter";
import BlankoElementComp from "./BlankoElementComp.vue";
import BlankoHeaderComp from "./BlankoHeaderComp.vue";

export default Vue.extend({
	name: "BlankoComp",
	components: { BlankoHeaderComp, BlankoElementComp },
	props: {
		raid: Object as PropType<userRaid>,
		boss: Object as PropType<Encounter>,
		elements: Array as PropType<blankoElement[]>,
		role: Number
	},
	computed: {
		blankoElements: function(): blankoElement[] {
			if (this.boss && this.elements) {
				return this.elements.filter(e => e.enc === this.boss.id);
			} else {
				return [];
			}
		},
	},
	methods: {
		propElement: function(position: number): blankoElement {
			if (this.blankoElements) {
				return this.blankoElements.find(e => e.pos === position);
			}
		},
		copyBlanko: function(info: number[]): void {
			this.$emit("copyBlanko", info);
		},
	},
});
